import React from 'react';

export type TvRefreshProblem = 'access' | 'connection' | null;

export default function TvRefreshNotice({ problem, lastUpdated }: { problem: TvRefreshProblem; lastUpdated: Date | null }) {
  if (!problem) return null;

  const accessProblem = problem === 'access';
  return (
    <div role="alert" style={{
      position: 'absolute', inset: 0, zIndex: 10, background: 'rgba(15, 25, 35, 0.96)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', padding: 80, color: '#fff',
    }}>
      <div style={{ fontSize: 76, marginBottom: 24 }}>{accessProblem ? '🔒' : '⚠️'}</div>
      <div style={{ fontSize: 52, fontWeight: 800, marginBottom: 18 }}>TV data is not updating</div>
      <div style={{ fontSize: 30, color: '#B8C9D9', maxWidth: 1050, lineHeight: 1.4 }}>
        {accessProblem
          ? 'This display link no longer matches the CRM access setting. Ask an administrator to reconnect this TV.'
          : 'The CRM could not be reached. Check the TV connection; this display will retry automatically.'}
      </div>
      {lastUpdated && <div style={{ fontSize: 24, color: '#8FA8C0', marginTop: 30 }}>
        Last updated {lastUpdated.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
      </div>}
    </div>
  );
}
